import userEvent from '@testing-library/user-event'
import { action, observable } from 'mobx'
import { RISK_TYPE } from '../constants'
import { RiskRequest } from '../requests/RiskRequest'

class riskStore {
  @observable riskList = []
  @observable total_count = []
  @observable total_page = []
  @observable riskUnits = []
  @observable riskDetail = {}
  @observable ruiRoNhanDienType = []
  @observable listTemplate = []

  // filter
  @observable filterPage = 0
  @observable filterSize = 10
  @observable type = null
  @action setQueryParams = (param, value) => {
    this[param] = value
  }
  @action clearQueryParams = () => {
    this.filterPage = 0
    this.filterSize = 10
    this.type = null
  }
  @action getRisks = () => {
    return new Promise((resolve, reject) => {
      RiskRequest.getRisks({
        page: this.filterPage,
        size: this.filterSize,
        type: this.type,
      })
        .then(response => {
          this.riskList = response.data.data
          this.total_count = response.data.total_count
          this.total_page = response.data.total_page
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createRisk = data => {
    return new Promise((resolve, reject) => {
      RiskRequest.createRisk(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getRiskUnits = () => {
    return new Promise((resolve, reject) => {
      RiskRequest.getRiskUnits()
        .then(response => {
          this.riskUnits = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getRiskDetail = riskCode => {
    return new Promise((resolve, reject) => {
      RiskRequest.getRiskDetail(riskCode)
        .then(response => {
          console.log('response', response)
          this.riskDetail = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action updateApproval = (code, data) => {
    return new Promise((resolve, reject) => {
      RiskRequest.updateApproval(code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action updateTierApproval = (code, data) => {
    return new Promise((resolve, reject) => {
      RiskRequest.updateTierApproval(code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateRisk = (code, data) => {
    return new Promise((resolve, reject) => {
      RiskRequest.updateRisk(code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getRuiRoNhanDienType = () => {
    return new Promise((resolve, reject) => {
      RiskRequest.getRuiRoNhanDienType()
        .then(response => {
          this.ruiRoNhanDienType = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getListTemplate = type => {
    return new Promise((resolve, reject) => {
      RiskRequest.getListTemplate({ type })
        .then(response => {
          this.listTemplate = response.data.map(record => ({
            ...record,
            rui_ro_nhan_dien: record.rui_ro_nhan_dien.replace(/\r\n/g, '<br/>'),
            bien_phap_phong_ngua_giam_thieu: record.bien_phap_phong_ngua_giam_thieu.replace(
              /\r\n/g,
              '<br/>'
            ),
            nguyen_nhan: record.nguyen_nhan.replace(/\r\n/g, '<br/>'),
          }))
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  /** Clear store */
  @action clearRiskStore = () => {
    this.riskList = []
    this.total_count = []
    this.total_page = []
    this.riskUnits = []
    this.riskDetail = []
    this.ruiRoNhanDienType = []
    this.listTemplate = []
  }
}

export default new riskStore()
